import cx from 'classnames';
import React, { useEffect, useRef } from 'react';

import styles from './wineLabel.module.scss';

interface WineLabelProps {
  altText: string;
  hasPerfectLabel: boolean;
  label: {
    medium_label: string;
    large_label: string;
  };
}

const WineLabel = ({ label, altText, hasPerfectLabel }: WineLabelProps) => {
  const imgRef = useRef<HTMLImageElement>(null);

  const setImageSize = (img: HTMLImageElement) => {
    const targetHeight = (img.parentNode as HTMLElement)?.clientHeight || 0;
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    img.height = targetHeight;
    img.width = (targetHeight * naturalWidth) / naturalHeight;
  };

  useEffect(() => {
    if (imgRef.current) {
      setImageSize(imgRef.current);
    }
  }, []);

  return (
    <picture className={cx(styles.picture, { [styles.imperfectLabel]: !hasPerfectLabel })}>
      <source
        media="(min-width: 425px)"
        srcSet={`${label.medium_label}, ${label.large_label} 2x`}
      />
      <img
        ref={imgRef}
        className={styles.image}
        alt={altText}
        src={label.medium_label}
        onLoad={() => {
          if (imgRef.current) {
            setImageSize(imgRef.current);
          }
        }}
      />
    </picture>
  );
};

export default WineLabel;
